<section class="offline-payment-instruction-overlay offline-payment-options-overlay popup-backgound w-100 h-100 fixed"
  id="overlayBlock">
  <div class="offline-payment-instruction-overlay-wrapper background-white round-top16 round-0-768">
    <img class="pointer" src="assets/images/close-white.svg" (click)="closeOverlay()" (keyup)="closeOverlay()"
      alt="close icon" class="mobile-close">
      <div class="instruction-overlay-title d-none d-md-block border-rgbaGrey500 round-top-4 py-24-768 px-32-768">
        <div class="d-flex justify-content-between">
          @if (!overlayInstructionBlock) {
            <h3 class="heading3-768 font-semibold text-black">View Payment Options </h3>
          }
          @if (overlayInstructionBlock) {
            <h3 class="heading3-768 font-semibold text-black">
            {{instructionData?.overlayTitle}}</h3>
          }
          <button class="closeButton" (click)="closeOverlay()" (keyup)="closeOverlay()">
            <img class="pointer" src="assets/images/close.svg" alt="close-icon" width="32" height="32"
              class="closeImage w-100 h-100" />
            </button>
          </div>
        </div>
        <div class="instruction-content-wrapper d-flex flex-column custom-scroll p-24 gap-24 gap-48-768 p-32-768 ">
          @if (overlayOfflineContent) {
            <div class="instruction-content-head d-flex flex-column gap-24 gap-16-768">
              <img src="assets/images/offline-payment-card.svg" alt="options-icon" class="options-icon">
              <div class="instruction-content-head-title d-flex flex-column gap-8 gap-8-768">
                <h4 class="heading2 heading2-768 font-bold">{{offlinePageData?.contentfulData?.title}}</h4>
                <span class="open-sans" [innerHTML]="offlinePageData?.contentfulData?.description"></span>
              </div>
            </div>
          }
          <div
            class="bookingreference pointer d-flex round-4 p-16 gap-8 gap-16-768 p-16-768 round-4-768 background-baseBlue50 border-left-baseBlue700"
            tabindex="0">
            <img class="info" src="/assets/images/information-circle-blue.svg" alt="alert-blue">
            <div class="bookingreference__id d-flex justify-content-md-between flex-column flex-md-row w-100">
              <h4 class="heading4 heading4-768 font-semibold txt-baseBlue700">Your booking reference ID</h4>
              <p class="font-open d-flex align-items-center gap-8 paragraph-small gap-8-768 paragraph-Medium-768 txt-baseBlue700 pointer toast w-auto"
                id="toastNo">
                <span class="toast-value">{{receiptNumber}}</span>
                <span class="copied-value">Reference ID copied</span>
                <span (click)="copyToClipboard(receiptNumber)" (keyup)="copyToClipboard(receiptNumber)" class="toast-image">
                  <img src="/assets/images/copy-blue.svg" alt="copy_blue" class="copy">
                  <img src="/assets/images/copy-blue-hover.svg" alt="copy_blue" class="copy-hover">
                  <img src="/assets/images/checkmark-blue.svg" alt="copy_blue" class="copied"></span>
                </p>
              </div>
            </div>
            @if (overlayOfflineContent) {
              <div class="Offline-option-content d-flex flex-column gap-20 gap-16-768">
                <h4 class="heading4 heading4-768 txt-burgundyRed500">View payment instructions</h4>
                <ul class="d-flex flex-column gap-20 gap-20-768">
                  @for (offlinePayment of offlinePageData?.finalData; track offlinePayment) {
                    <li
                      class="d-flex align-items-center background-white pointer p-20 gap-12 border-rgbaGrey500 round-8 round-8-768 gap-16-768 p-24-768"
                      (click)="openOverlay(offlinePayment)" (keyup)="openOverlay(offlinePayment)"
                      [class.disablePointer]="!offlinePayment.instructions"
                      tabindex="0">
                      <img src={{offlinePayment?.image[0]?.url}} alt="cash-outline" class="optionImg" />
                      <div class="d-flex flex-column Offline-option-content-box gap-4-0 gap-4-768">
                        <h4 class="heading4 heading4-768 txt-charcoalGrey500 font-semibold">{{offlinePayment?.title}}</h4>
                      </div>
                      @if (offlinePayment.instructions) {
                        <img src="/assets/images/chevron-right-gray.svg" alt="arrow-right">
                      }
                    </li>
                  }
                </ul>
              </div>
            }
            @if (overlayInstructionBlock) {
              <div class="instruction-content-container d-flex flex-column">
                <div class="instruction-content-body d-flex flex-column">
                  <span [innerHTML]="paymentInstructions"></span>
                </div>
              </div>
            }
            <div class="instruction-button-sec py-20 px-24 py-36-768 px-32-768 background-white">
              <div
                class="instruction-button-sec-container d-flex flex-column flex-md-row justify-content-between align-items-center gap-16 gap-16-768">
                <a (click)="backToPopup()" (keyup)="backToPopup()"
                  class="back-link txt-charcoalGrey500 font-semibold padding-0-768 py-12 px-24 round-4 border-grey500 border-0-768 text-center text-md-start round-100 round-0-768"
                tabindex="0">Back</a>
              </div>
            </div>
          </div>
        </div>
      </section>